import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, Grid, IconButton, TextField, Typography } from '@mui/material';

function newOption(text = '') {
  return { key: `opt-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`, text };
}

export function optionsToStrings(rows) {
  return rows.map((r) => String(r.text ?? '').trim()).filter(Boolean);
}

export function stringsToOptionRows(strings) {
  const arr = Array.isArray(strings) ? strings : [];
  if (arr.length === 0) {
    return [newOption(), newOption()];
  }
  return arr.map((text) => newOption(text));
}

const FeedbackOptionsEditor = ({ options, setOptions, colors }) => {
  const handleOptionChange = (key, value) => {
    setOptions(options.map((row) => (row.key === key ? { ...row, text: value } : row)));
  };

  const addOption = () => {
    setOptions([...options, newOption()]);
  };

  const removeOption = (key) => {
    if (options.length <= 1) return;
    setOptions(options.filter((row) => row.key !== key));
  };

  return (
    <Box mb={2}>
      <Typography variant="h5" mb={1} color={colors.grey[100]}>
        Answer Options
      </Typography>

      <Grid container spacing={2}>
        {options.map((row, index) => (
          <Grid item xs={12} md={6} key={row.key} display="flex" alignItems="center" gap={1}>
            <TextField
              fullWidth
              variant="filled"
              type="text"
              label={`Option ${index + 1}`}
              value={row.text}
              onChange={(e) => handleOptionChange(row.key, e.target.value)}
            />
            <IconButton
              aria-label="remove option"
              onClick={() => removeOption(row.key)}
              disabled={options.length <= 1}
              sx={{ color: colors.redAccent[400] }}
            >
              <DeleteIcon />
            </IconButton>
          </Grid>
        ))}
      </Grid>

      <Button
        type="button"
        startIcon={<AddIcon />}
        onClick={addOption}
        sx={{
          mt: 2,
          color: colors.grey[100],
          borderColor: colors.grey[400],
        }}
        variant="outlined"
      >
        Add Option
      </Button>
    </Box>
  );
};

export default FeedbackOptionsEditor;
